export default __webpack_public_path__ + "static/media/bitcoin.429df463.svg";